module.exports = __webpack_public_path__ + "assets/img/gar8-3.9ee3af76.jpg";